import React from 'react';
import cx from 'classnames';
import Text, { Headline, TextSize } from '@move-ui/text';
import { PrimaryButton, ButtonSize } from '@move-ui/button';
import styles from './EmptyContent.module.css';
export const EmptyContent = ({ 'data-testid': testId, className, title, subtitle, imageSrc, imageAlt, ButtonComponent = PrimaryButton, buttonProps, buttonText, header, footer }) => (React.createElement("div", { className: cx(styles.component, className), "data-testid": testId },
    header,
    React.createElement("img", { className: styles.image, alt: imageAlt, src: imageSrc }),
    React.createElement(Headline, { size: TextSize.XL, color: "neutral-100", bold: true, level: 1, className: styles.title }, title),
    React.createElement("p", { className: styles.subtitle },
        React.createElement(Text, { size: TextSize.M, color: "neutral-200" }, subtitle)),
    buttonText && (React.createElement(ButtonComponent, Object.assign({ size: ButtonSize.Size200 }, buttonProps), buttonText)),
    footer));
//# sourceMappingURL=EmptyContent.js.map